import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainNav from "./features/nav/MainNav";
import Wagers from "./features/wagers/containers/Wagers";
import Home from "./Home";

import "./App.css";
import Login from "./features/auth/components/Login";
import Callback from "./features/auth/components/Callback";
import Register from "./features/registration/Register";
import { Signout } from "./features/auth/components/Signout";
import Layout from "./features/layout/Layout";
import WagerView from "./features/wagers/components/WagerView";
import GameView from "./features/games/components/GameView";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <Router>
        <MainNav />
        <Layout>
          <Routes>
            <Route index element={<Home />} />

            <Route path="/wagers" element={<Wagers />} />
            <Route path="/wagers/:wagerId" element={<WagerView />} />

            <Route path="/login" element={<Login />} />
            <Route path="/signin-oidc" element={<Callback />} />
            <Route path="/signout-callback-oidc" element={<Signout />} />
            <Route path="/signout-oidc" element={<Signout />} />

            <Route path="/register" element={<Register />} />

            <Route path="/games/:gameTitle" element={<GameView />} />
          </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
